import React from 'react';
import TextScale from 'packages/pages/editor/RightSideMenu/Shots/Text/TextScale';
import { SCALE_PROPS, TextScaleProps } from 'packages/pages/editor/RightSideMenu/Shots/Text/TextScale/types';

const MinFontScale = (props: TextScaleProps) => <TextScale {...props} propName={SCALE_PROPS.MIN_FONT_SCALE} />;

export default MinFontScale;
